"use client";

import { createContext, useContext, useState, ReactNode } from "react";
import { GridRowSelectionModel, GridRowId } from "@mui/x-data-grid-pro";
import { SelfUser } from "@/api/users";

interface CampaignDialogsContextType {
  currentUser: SelfUser | null;
  isAdmin: boolean;
  rowSelectionModel: GridRowSelectionModel;
  setRowSelectionModel: (model: GridRowSelectionModel) => void;
}

const CampaignDialogsContext = createContext<
  CampaignDialogsContextType | undefined
>(undefined);

export const useCampaignDialogs = () => {
  const context = useContext(CampaignDialogsContext);
  if (!context) {
    throw new Error(
      "useCampaignDialogs must be used within CampaignDialogsProvider",
    );
  }
  return context;
};

interface CampaignDialogsProviderProps {
  children: ReactNode;
  currentUser: SelfUser;
  isAdmin: boolean;
}

export function CampaignDialogsProvider({
  children,
  isAdmin,
  currentUser,
}: CampaignDialogsProviderProps) {
  // Row selection model (managed by DataGrid)
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>({
      ids: new Set<GridRowId>([]),
      type: "include",
    });

  const value: CampaignDialogsContextType = {
    isAdmin,
    currentUser,
    rowSelectionModel,
    setRowSelectionModel,
  };

  return (
    <CampaignDialogsContext.Provider value={value}>
      {children}
    </CampaignDialogsContext.Provider>
  );
}
